<template>
	<section
		:class="{ teal: compProps.teal, blue: compProps.blue }"
		:style="{
			backgroundImage: `url(${compProps.image})`,
			backgroundSize: 'contain',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
		}"
	>
		<div class="container">
			<slot></slot>
		</div>
		<Wave v-if="compProps.wave" :color="compProps.waveColor" />
		<div v-if="$slots.footer" class="footer-container" :style="{ backgroundColor: compProps.waveColor }">
			<slot name="footer"></slot>
		</div>
	</section>
</template>

<script setup lang="ts">
import Wave from "./Wave.vue";
const compProps = defineProps({
	teal: {
		type: Boolean,
		required: false,
		default: false,
	},
	blue: {
		type: Boolean,
		required: false,
		default: false,
	},
	wave: {
		type: Boolean,
		required: false,
		default: false,
	},
	waveColor: {
		type: String,
		required: false,
		default: "",
	},
	wavetype: {
		type: String,
		default: "wave",
	},
	image: {
		type: String,
		required: false,
		default: "",
	},
});
</script>

<style scoped lang="scss">
.teal {
	background-image: linear-gradient(180deg, #80cb9f, #80cbc4, #80adcb);
}

.blue {
	background-image: linear-gradient(180deg, #80adcb, #80cbc4, #80adcb);
}

.container {
	position: relative;
	width: 100%;
	max-width: 1440px;
	margin: 0px auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex: 1;
}
section {
	display: flex;
	flex-direction: column;
}

.footer-container {
	padding-top: 3rem;
}
</style>
